var map = {
	"./hhu/data-publig-doc.json": 17981,
	"./ril/data-publig-doc.json": 13145,
	"./rub/data-publig-doc.json": 37751,
	"./tudo/data-publig-doc.json": 42608,
	"./uwh/data-publig-doc.json": 87098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20365;